/**
 * 禁止ドメインリストに引数に渡されたドメインが含まれていることを検証する
 *
 * - 含まれている場合は禁止されているので検証は失敗し、false となる
 * - 含まれていない場合は禁止されていないので検証は成功し、true となる
 */
export function validateDisallowDomains(disallowDomainsStr: string, domain: string) {
  if (disallowDomainsStr === '') {
    // 空の場合は禁止ドメイン指定がないので true を返す
    return true;
  }

  if (disallowDomainsStr === '*') {
    // * の場合は全てのドメインを禁止しているため false を返す
    return false;
  }

  return !disallowDomainsStr.split(',').includes(domain);
}
